export default __webpack_public_path__ + "static/media/profile-blank-photo.73bd52de.svg";